import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'
import type { SaveSlot, Achievement, RankEntry } from '../types/index.js'

export class GameAchievementsController {
  constructor(private rpc: RpcEngine) {}

  unlock(achievementId: string): Promise<void> {
    return this.rpc.call(METHODS.GAME_ACHIEVEMENT_UNLOCK, [achievementId])
  }

  list(): Promise<Achievement[]> {
    return this.rpc.call(METHODS.GAME_ACHIEVEMENT_LIST)
  }
}

export class GameRankingController {
  constructor(private rpc: RpcEngine) {}

  submit(score: number, options?: { category?: string }): Promise<void> {
    return this.rpc.call(METHODS.GAME_RANKING_SUBMIT, [score, options])
  }

  getTop(options?: { limit?: number; category?: string }): Promise<RankEntry[]> {
    return this.rpc.call(METHODS.GAME_RANKING_TOP, [options])
  }

  getSelf(options?: { category?: string }): Promise<RankEntry> {
    return this.rpc.call(METHODS.GAME_RANKING_SELF, [options])
  }
}

export class GameModule {
  readonly achievements: GameAchievementsController
  readonly ranking: GameRankingController

  constructor(private rpc: RpcEngine) {
    this.achievements = new GameAchievementsController(rpc)
    this.ranking = new GameRankingController(rpc)
  }

  save(options: { slot: number; description?: string }):    Promise<void>        { return this.rpc.call(METHODS.GAME_SAVE, [options]) }
  load(options: { slot: number }):                          Promise<Record<string, unknown>> { return this.rpc.call(METHODS.GAME_LOAD, [options]) }
  listSaves():                                              Promise<SaveSlot[]>  { return this.rpc.call(METHODS.GAME_SAVE_LIST) }
  deleteSave(slot: number):                                 Promise<void>        { return this.rpc.call(METHODS.GAME_SAVE_DELETE, [slot]) }

  unlockAchievement(achievementId: string):                 Promise<void>        { return this.achievements.unlock(achievementId) }
  listAchievements():                                       Promise<Achievement[]>{ return this.achievements.list() }

  submitScore(score: number, options?: { category?: string }):   Promise<void>    { return this.ranking.submit(score, options) }
  getTop(options?: { limit?: number; category?: string }):       Promise<RankEntry[]>{ return this.ranking.getTop(options) }
  getSelfRank(options?: { category?: string }):                  Promise<RankEntry>{ return this.ranking.getSelf(options) }
}
